import { Pipe, PipeTransform } from "@angular/core";

/**
 * Retourne la première ligne d'un contenu HTML, sans balises.
 * Ajoute un suffixe (par défaut "...") s'il existe d'autres lignes.
 *
 * Ex: "<p><strong>Le Soleil</strong></p><p>Qui est le principe de l'Ego.</p>"
 *  -> "Le Soleil..."
 */
@Pipe({
  name: "firstLine",
  standalone: true,
})
export class FirstLinePipe implements PipeTransform {
  transform(value: string | null | undefined, suffix = "..."): string {
    if (!value) {
      return "";
    }

    // Transforme les fins de blocs (</p>, </div>, </li>, </h1-6>, <br>) en saut de ligne
    const withBreaks = value.replace(
      /<\/(p|div|li|h[1-6])>|<br\s*\/?>/gi,
      "\n",
    );

    // Retire toutes les balises restantes puis décode les entités courantes
    const text = this.decode(withBreaks.replace(/<[^>]*>/g, ""));

    // Découpe en lignes non vides
    const lines = text
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

    if (lines.length === 0) {
      return "";
    }

    return lines.length > 1 ? `${lines[0]}${suffix}` : lines[0];
  }

  private decode(value: string): string {
    const entities: Record<string, string> = {
      "&nbsp;": " ",
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'",
      "&apos;": "'",
    };

    return value.replace(
      /&nbsp;|&amp;|&lt;|&gt;|&quot;|&#39;|&apos;/g,
      (match) => entities[match],
    );
  }
}
